import React, { Component } from 'react'
import ToggleSection from 'components/shared/ToggleSection'
import * as OrgSelectors from 'app/modules/org/selectors'
import withNotifications from 'components/shared/notifications'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { partial, defaultTo } from 'ramda'
import { fetchOrgProperties } from 'app/modules/org/actions'
import { toggleVidyardIntegration } from 'app/modules/integrations/api'
import app from 'containers/app'

const TOGGLE_ERROR_MESSAGE = 'Oops, something went wrong. Please try again.'
const defaultToEmptyObject = defaultTo({})

class Vidyard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isEnabled: props.isEnabled
    }
  }

  refreshOrgProperties = () => {
    return this.props.actions.fetchOrgProperties()
  }

  refreshIntegrationState = () => {
    app.queries.IntegrationsQueries.fetchIntegrationStates()
  }

  toggleEnabled = (isEnabled) => {
    const onError = () => {
      this.props.notifications.error(TOGGLE_ERROR_MESSAGE)
      this.setState({ isEnabled: !isEnabled })
    }

    const onLocalStateSet = () => {
      toggleVidyardIntegration(isEnabled)
        .catch(onError)
        .then(this.refreshOrgProperties)
        .then(this.refreshIntegrationState)
    }

    this.setState({ isEnabled }, onLocalStateSet)
  }

  render() {
    const { isEnabled } = this.state

    return (
      <div>
        <p className="vidyard-description">
          Turn on Vidyard’s GoVideo widget and start building stronger relationships with your leads and customers through video.
          If your team has Vidyard accounts, they’ll be able to send personalized videos and screen recordings right from Drift.
          <a
            className="vidyard-help-doc-link"
            href="https://help.drift.com/integrations/vidyard-integration-send-personalized-videos-and-screen-recordings-right-from-drift"
            target="_blank">
              Learn More
          </a>
        </p>
        <ToggleSection
          title="Add Vidyard to Drift"
          description="Adds a button to your Conversations view to launch the GoVideo widget"
          isActive={isEnabled}
          onToggled={partial(this.toggleEnabled, [!isEnabled])}
          className="vidyard-toggle-section"
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isEnabled: defaultToEmptyObject(OrgSelectors.properties(state)).isVidyardEnabled
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ fetchOrgProperties }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withNotifications(Vidyard)
)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Vidyard.js